import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const ChristmasSnow = () => {
  const [isChristmasSeason, setIsChristmasSeason] = useState(false);

  useEffect(() => {
    // Auto-enable from November 21st through January 6th (Epiphany)
    const checkChristmasSeason = () => {
      const now = new Date();
      const month = now.getMonth(); // 0-indexed (10 = November, 11 = December, 0 = January)
      const day = now.getDate();
      
      // November 21st onwards (month 10, day >= 21), all of December (month 11), or January 1-6 (month 0, day 1-6)
      const isActive = (month === 10 && day >= 21) || month === 11 || (month === 0 && day <= 6);
      setIsChristmasSeason(isActive);
    };

    checkChristmasSeason();
  }, []);

  if (!isChristmasSeason) return null;

  // Generate snowflakes with varied positions and animations
  const snowflakes = Array.from({ length: 50 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    animationDelay: `${Math.random() * 10}s`,
    animationDuration: `${10 + Math.random() * 20}s`,
    opacity: 0.3 + Math.random() * 0.4,
    size: 2 + Math.random() * 4,
  }));

  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden">
      {snowflakes.map((flake) => (
        <motion.div
          key={flake.id}
          className="absolute rounded-full bg-white"
          style={{
            left: flake.left,
            top: "-10px",
            width: `${flake.size}px`,
            height: `${flake.size}px`,
            opacity: flake.opacity,
          }}
          animate={{
            y: ["0vh", "110vh"],
            x: [0, Math.sin(flake.id) * 50, 0],
          }}
          transition={{
            duration: parseFloat(flake.animationDuration),
            delay: parseFloat(flake.animationDelay),
            repeat: Infinity,
            ease: "linear",
          }}
        />
      ))}
    </div>
  );
};
